export default function createDispatch(toolname) {
    function dispatchGoogleEvent(type) {
        /* eslint-disable no-undef */
        window.document.dispatchEvent(new CustomEvent(
            'SERVICE_TOOLS_GA',
            { detail: { type, toolname } },
        ));
        /* eslint-enable no-undef */
    }

    let dirty = false;

    const instance = {
        onLoad() {
            dispatchGoogleEvent('load');
        },
        onForceChange() {
            dirty = false;
            dispatchGoogleEvent('change');
        },
        onChange() {
            dirty = true;
        },
        onBlur() {
            if (dirty) {
                dirty = false;
                dispatchGoogleEvent('change');
            }
        },
        onResult() {
            dispatchGoogleEvent('result');
        },
        onDetails() {
            dispatchGoogleEvent('details');
        },
    };

    return instance;
}




// WEBPACK FOOTER //
// ./src/frontend/common/googleAnalytics/eventDispatcher.js